import React from 'react';

import Text from '../../../components/Text';

export default function FlinksConnectErrorMessage({ showSkipMessage }) {
  return showSkipMessage
    ? <p><Text value="ErrorLoadingBankingWithSkipPrompt" /></p>
    : <p><Text value="ErrorLoadingBanking" /></p>;
}
